import { render, staticRenderFns } from "./RecentActivityTableDescriptionReminderSent.vue?vue&type=template&id=4db1854b&"
import script from "./RecentActivityTableDescriptionReminderSent.vue?vue&type=script&lang=js&"
export * from "./RecentActivityTableDescriptionReminderSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports